import React from "react";
import Sidebar from "../../../components/AdminComponents/SideNav";

import { SettingsMenu } from "../../../components/AdminComponents/MenuItems";
/* eslint-disable no-unused-vars */
import { Table, Button, Input, Spin, Tag, Pagination } from "antd";
import { useState, useEffect } from "react";
import { DeleteTwoTone } from "@ant-design/icons";

// import "./settingStyles.css";

import Axios from "../../../api/Axios";
import EditableImage from "../../../components/icons/EditIcon";
import { useNavigate } from "react-router-dom";
import {
  capitalizeWords,
  ModuleColor,
  ModuleTagName,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import { getUpdateStatus2 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
const ModuleRoles = () => {
  const history = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus2(userInfo, 1, 0);
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/rolelist/`,
    search: "",
  });
  const { pageSize, currentPage, url, search } = filterData;
  const LoadUser = async () => {
    let doNothing = false;
    let passUrl = url;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        setData(res.data.results);
        setItemsLength(res.data.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };

  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);

  const columns = [
    {
      title: capitalizeWords("role id"),
      dataIndex: "role_id",
      key: "role_id",
    },
    {
      title: capitalizeWords("role name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: capitalizeWords("user group"),
      dataIndex: "user_group",
      key: "user_group",
    },
    {
      title: capitalizeWords("scope"),
      dataIndex: "scope",
      key: "scope",
    },
    {
      title: capitalizeWords("applications"),
      dataIndex: "applications",
      key: "applications",
      width: 200,
      render: (applications) => (
        <span>
          {applications.map((tag, index) => {
            return (
              <Tag
                color={ModuleColor(tag.name)}
                key={index}
                title={tag.name}
                style={{ margin: "3px" }}
              >
                <span style={{ color: "black", fontWeight: "500" }}>
                  {ModuleTagName(tag.name)}
                </span>
              </Tag>
            );
          })}
        </span>
      ),
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("actions"),
            key: "actions",
            align: "center", // Added align: "center" for ACTIONS
            render: (text, record) => {
              return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {/* <DeleteTwoTone onClick={handleClick(record)} /> */}
                  <EditableImage
                    handleRowClick={handleRowClick}
                    recordId={record.id}
                  />
                  <DeleteTwoTone
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleRowClick = (record) => {
    history(`/access-manager/roles/edit-role/${record}`);
  };
  return (
    <Sidebar props={SettingsMenu}>
      <CommonTopDetails
        title="Roles Summary"
        titleSuffix={`${itemsLength || 0} role(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={updateAuth}
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: `/access-manager/roles/add-role`,
        }}
      />

      <Spin spinning={loading}>
        <Table
          size="small"
          dataSource={data}
          columns={columns}
          bordered
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(24)}px`,
          }}
          className="table-container"
          style={{ margin: "1rem" }}
          pagination={false}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
      {/* </div> */}
    </Sidebar>
  );
};

export default ModuleRoles;
